export const QUERY_STRING_DAYJS_FORMAT = 'DD-MM-YYYY'
